import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Action } from '../constants/action-catalogue';
import { ProfileDataService } from '../services/profile-data.service';
import { ViewerService } from '../services/viewer.service';
import { isAdminPreview } from './admin-preview';

/** Deep-link guard matching the global aggregate report's server RBAC. */
export function gamificationAnalyticsGuard(): CanActivateFn {
  return async (route) => {
    if (isAdminPreview(route)) return true;
    const viewer = inject(ViewerService);
    const profile = inject(ProfileDataService);
    const router = inject(Router);
    await viewer.ensureLoaded();
    return profile.canDo(Action.INSIGHTS_VIEW_GLOBAL)
      ? true
      : router.createUrlTree(['/home-preview']);
  };
}
